import { useId } from "react";
import { Field } from "../ui/Field.js";
import { SegmentedControl, type OpcjaSegmentu } from "../ui/SegmentedControl.js";
import { Select } from "../ui/Select.js";

/** SG-3: do pieciu opcji przelacznik segmentowy, wiecej - lista rozwijana (jak przy wyborze mowcy w karcie oceny). */
export const MAKS_SEGMENTOW_WYBORU = 5;

/**
 * Wybor jednego mowcy z listy: "Kim jestes w tej rozmowie?" (formularz) i "Wynik dla:" (ekran wyniku).
 *
 * Do pieciu opcji to przelacznik segmentowy (SG-3), wiecej to lista rozwijana z etykieta nad polem (F-1). Przy
 * segmentach widoczna etykieta jest opcjonalna: formularz ma pytanie w tytule karty, a przelacznik dostaje `aria-label`
 * tak czy inaczej (A-5).
 */
export function WyborMowcy({
  etykieta,
  opcje,
  wartosc,
  onZmiana,
  widocznaEtykieta = true,
}: {
  etykieta: string;
  opcje: readonly OpcjaSegmentu[];
  wartosc: string;
  onZmiana: (wartosc: string) => void;
  widocznaEtykieta?: boolean;
}): React.JSX.Element {
  const id = useId();

  if (opcje.length > MAKS_SEGMENTOW_WYBORU) {
    return (
      <Field etykieta={etykieta} id={`${id}-wybor`} waskie>
        {(atrybuty) => <Select {...atrybuty} wartosc={wartosc} opcje={opcje} onZmiana={onZmiana} />}
      </Field>
    );
  }

  return (
    <div className="wynik-wybor">
      {widocznaEtykieta && <span className="field-label">{etykieta}</span>}
      <SegmentedControl etykieta={etykieta} opcje={opcje} wartosc={wartosc} onZmiana={onZmiana} />
    </div>
  );
}
